import styled from 'styled-components'
import InfoTooltip from './Common/InfoTooltip'
import React from 'react'

export const Wrapper = styled.div`
  background: ${({theme}) => theme.primaryGradient};
  // background url is loaded in _custom.scss because of webpack assets loading
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  min-height: 100vh;
  position: relative;
  z-index: 10;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
 
`

export const Overlay = styled.div`
  position: absolute;
  background: #000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  opacity: .1;
`

export const Container = styled.div`
  position: relative;
  z-index: 30;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Logo = styled.img`
  max-width: 140px;
`

export const LoginContainer = styled.div`
  background: rgba(255, 255, 255, .7);
  border-radius: 5px;
  padding: 2.8rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
  position: relative;
`

export const Input = (props) => {
  if (props.info) {
    return (
      <InputWithInfoContainer>
        <InfoTooltip text={props.info} position="up"/>
        <StyledInput {...props}/>
      </InputWithInfoContainer>
    )
  }
  return <StyledInput {...props}/>
}

export const StyledInput = styled.input`
  width: 200px;
  background: none;
  border: none;
  border-bottom: 1px solid #7f8c8d;
  padding: .3rem;
  -webkit-appearance: none;
  appearance: none;
  &, &:focus {
    outline: none;
  }
`

const InputWithInfoContainer = styled.div`
  position: relative;
  
  ${StyledInput} {
    padding-left: 1.5rem;
  }
  // span - tooltip
  span {
    position: absolute;
    top: 3px;
  }
`

export const Link = styled.span`
  color: ${({theme}) => theme.primary};
  font-size: .8rem;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`

export const LanguageContainer = styled.div`
  position: absolute;
  top: 0;
  right: 3rem;
  z-index: 30;
`

export const ErrorMessage = styled.span`
  color: ${({theme}) => theme.sosColor};
  font-size: .8rem;
  position: absolute;
  left: 2rem;
  right: 2rem;
  top: .5rem;
  font-weight: 500;
`
